import Script from "next/script"
import { Member } from "../_entities/member"

type GaTagProps = {
  gaId: string
  adminMember?: Member
}

export const GaTag = ({ gaId, adminMember }: GaTagProps) => {
  const gtagSource = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
  const gtagBody = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${gaId}', {'user_id': '${adminMember?.id}'});
`
  return (
    <>
      {/* Google Analytic Setup */}
      {/* reference: https://nextjs.org/docs/messages/next-script-for-ga */}
      <Script async src={gtagSource}></Script>
      <Script id="google-analytics">{gtagBody}</Script>
    </>
  )
}
